<ng-container *ngIf="isMobile$ | async; else desktop">
  <div class="pax-celebrate-cont animated {{animation}}">
    <ng-container *ngTemplateOutlet="celebrationView; context: { isMobileView: true }"></ng-container>
  </div>
</ng-container>

<ng-template #desktop>
  <app-modal [width]="400">
    <ng-container content>
      <div class="pax-celebrate-cont desktop">
        <ng-container *ngTemplateOutlet="celebrationView; context: { isMobileView: false }"></ng-container>
      </div>
    </ng-container>
  </app-modal>
</ng-template>

<ng-template #celebrationView let-isMobileView="isMobileView">
  <div class="header-cont">
    <i aria-hidden="true" class="icon-close" (click)="close()"></i>
  </div>
  <div class="body-cont" [ngStyle]="celebrateStyles(image | baseImage: PAX_CELEBRATE_IMAGES_BASE_PATH, isMobile$ | async)">
    <div class="info-body">
      <h3>{{ 'BOOKING_MODULE.PAX.CELEBRATE.TITLE' | transloco }}</h3>
      <h3 class="sub">{{ 'BOOKING_MODULE.PAX.CELEBRATE.SUB_TITLE' | transloco }}</h3>
      <p>
        {{ 'BOOKING_MODULE.PAX.CELEBRATE.DESCRIPTION' | transloco }}
      </p>
    </div>
  </div>
  <div class="paxCelebrate__buttonCont" *ngIf="isMobileView">
    <app-ds-button
      class="paxCelebrate__buttonCont__button"
      [labels]="{ ButtonLabel: 'BUTTONS.CONTINUE' | transloco }"
      (clickEvent)="close()">
    </app-ds-button>
  </div>
</ng-template>